import React, { useEffect, useState } from 'react';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { Button } from '@progress/kendo-react-buttons';
import FormInput from 'src/shared/components/forms/FormInput';
import { NumericTextBox, Checkbox } from '@progress/kendo-react-inputs';
import UnitTypesDropdown from 'src/shared/components/dropdowns/UnitTypesDropdown';
import { SaveButton } from '../../../../shared/components/buttons';
import PageForm from 'src/shared/components/forms/PageForm';
const AdditionalChargeForm = ({ data, onCancel, onSubmit }) => {
  const [additionalCharge, setAdditionalCharge] = useState(data);

  useEffect(() => {
    if (data) {
      setAdditionalCharge(data);
    }
  }, []);

  return (
    <PageForm
      onSubmit={onSubmit}
      initialValues={additionalCharge}
      key={JSON.stringify(additionalCharge)}
      id='additional-charge'
      onClose={onCancel}
      hideActionBar
      renderFields={(formRenderProps) => (
        <FormElement>
          <fieldset className={'k-form-fieldset'}>
            <Field id={'description'} name={'description'} label={'Description'} component={FormInput} />
            <Field
              id={'standardRate'}
              name={'standardRate'}
              label={'Standard Rate'}
              min={0}
              component={FormInput}
              format='c2'
              inputComponent={NumericTextBox}
            />
            <Field
              id={'operatorHours'}
              name={'operatorHours'}
              label={'Operator Hours'}
              min={0}
              component={FormInput}
              inputComponent={NumericTextBox}
            />
            <Field
              id={'clerkHours'}
              name={'clerkHours'}
              label={'Clerk Hours'}
              min={0}
              component={FormInput}
              inputComponent={NumericTextBox}
            />
            <Field
              id={'muleHours'}
              name={'muleHours'}
              label={'Mule Hours'}
              min={0}
              component={FormInput}
              inputComponent={NumericTextBox}
            />
            <Field
              id={'materialCosts'}
              name={'materialCosts'}
              label={'Material Costs'}
              min={0}
              component={FormInput}
              format='c2'
              inputComponent={NumericTextBox}
            />
            <Field
              id={'unitType'}
              name={'unitType'}
              label={'Unit Type'}
              component={FormInput}
              inputComponent={UnitTypesDropdown}
            />
            <br />
            <Field id={'displayOnTariff'} name={'displayOnTariff'} label={'Display on Tariff'} component={Checkbox} />
          </fieldset>
        </FormElement>
      )}
    />
  );
};

export default AdditionalChargeForm;
